(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-pdp-signature-v2"]) return;
  try {
    
// --- Variant state ---
const state = { qty: 1 };

// Firmness / Warmth indicator is now informational (driven by metafield), not interactive.

// Multi-option variant picker — works for single-option and multi-option products alike.
// Formatér øre-beløb som fx "1.298 kr" (samme stil som money_without_trailing_zeros)
function formatMoneyV2(cents) {
  return Math.round(cents / 100).toLocaleString('da-DK') + ' kr';
}

(function () {
  var dataEl = document.getElementById('pdp-v2-variants');
  if (!dataEl) return;

  var variantData;
  try { variantData = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var optionNames = variantData.options;
  var variants = variantData.variants;
  if (!variants.length || !optionNames.length) return;

  // Start fra den faktisk valgte variant (?variant= i URL, ellers den Liquid har valgt)
  var urlVariant = parseInt(new URLSearchParams(location.search).get('variant'), 10);
  var initialVariant =
    variants.find(function (v) { return v.id === urlVariant; }) ||
    variants.find(function (v) { return v.id === variantData.current_id; }) ||
    variants[0];
  var selected = {};
  optionNames.forEach(function (n, i) { selected[n] = initialVariant.options[i]; });

  function findMatch() {
    return variants.find(function (v) {
      return optionNames.every(function (n, i) { return v.options[i] === selected[n]; });
    });
  }

  function syncUi() {
    var match = findMatch();
    var vid = document.getElementById('variant-id');
    if (match && vid) vid.value = match.id;

    // Update price, before-price, save-% and the price inside the orange ATC button
    if (match) {
      var priceEl = document.querySelector('.price-now');
      if (priceEl) priceEl.textContent = match.price_formatted;

      var cap = match.compare_at_price || 0;
      var savePct = cap > match.price ? Math.round((cap - match.price) * 100 / cap) : 0;

      var wasEl = document.querySelector('.price-was');
      if (wasEl) {
        if (savePct > 0) { wasEl.textContent = formatMoneyV2(cap); wasEl.removeAttribute('hidden'); }
        else wasEl.setAttribute('hidden', 'hidden');
      }
      var saveEl = document.querySelector('.price-save');
      if (saveEl) {
        if (savePct > 0) { saveEl.textContent = 'Spar ' + savePct + '%'; saveEl.removeAttribute('hidden'); }
        else saveEl.setAttribute('hidden', 'hidden');
      }
      var atcPrice = document.querySelector('[data-atc-price]');
      if (atcPrice) atcPrice.textContent = match.price_formatted;
      var atcSave = document.querySelector('[data-atc-save]');
      if (atcSave) {
        if (savePct > 0) { atcSave.textContent = 'spar ' + savePct + '%'; atcSave.removeAttribute('hidden'); }
        else atcSave.setAttribute('hidden', 'hidden');
      }
    }

    // Update each option group's selected-name label and is-active highlight
    optionNames.forEach(function (n) {
      document.querySelectorAll('.option-btn[data-option-name="' + CSS.escape(n) + '"]').forEach(function (btn) {
        if (btn.dataset.optionValue === selected[n]) btn.classList.add('is-active');
        else btn.classList.remove('is-active');
      });
      var lbl = document.querySelector('.selected-name[data-option-label="' + CSS.escape(n) + '"]');
      if (lbl) lbl.textContent = selected[n];
    });

    // Disable CTA if unavailable
    var cta = document.querySelector('.cta-primary');
    if (cta) {
      if (match && match.available) {
        cta.removeAttribute('disabled');
        cta.style.opacity = '';
      } else {
        cta.setAttribute('disabled', 'disabled');
        cta.style.opacity = '0.55';
      }
    }

    // Update URL with variant query param for sharing
    if (match && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
    }
  }

  document.querySelectorAll('.option-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var optName = btn.dataset.optionName;
      var optValue = btn.dataset.optionValue;
      if (!optName) return;
      selected[optName] = optValue;
      syncUi();
    });
  });

  syncUi();
})();

// Color swatches (only render when product has a Color/Farve option)
document.querySelectorAll('.swatch').forEach(function(s) {
  s.addEventListener('click', function() {
    document.querySelectorAll('.swatch').forEach(function(b) { b.classList.remove('is-active'); });
    s.classList.add('is-active');
    var lbl = s.closest('.option-group').querySelector('.selected-name');
    if (lbl) lbl.textContent = s.dataset.color;
  });
});

// Qty
var qtyInput = document.getElementById('qtyInput');
var qtyMinus = document.getElementById('qtyMinus');
var qtyPlus = document.getElementById('qtyPlus');
if (qtyMinus) qtyMinus.addEventListener('click', function() {
  state.qty = Math.max(1, state.qty - 1);
  if (qtyInput) qtyInput.value = state.qty;
});
if (qtyPlus) qtyPlus.addEventListener('click', function() {
  state.qty += 1;
  if (qtyInput) qtyInput.value = state.qty;
});

// Gallery — prev/next arrows page through the stacked, cross-faded slides.
(function () {
  var main = document.querySelector('.gallery__main');
  if (!main) return;
  var slides = main.querySelectorAll('.gallery__slide');
  var prev = main.querySelector('[data-gallery-prev]');
  var next = main.querySelector('[data-gallery-next]');
  var counter = main.querySelector('[data-gallery-index]');
  if (slides.length < 2 || !prev || !next) return;

  var index = 0;
  function show(i) {
    index = (i + slides.length) % slides.length; // wraps both ways
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
    if (counter) counter.textContent = index + 1;
  }

  prev.addEventListener('click', function () { show(index - 1); });
  next.addEventListener('click', function () { show(index + 1); });
  main.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { show(index - 1); }
    if (e.key === 'ArrowRight') { show(index + 1); }
  });

  show(0);
})();

// FAQ accordion
document.querySelectorAll('.faq-item__q').forEach(function(q) {
  q.addEventListener('click', function() {
    var item = q.parentElement;
    var wasOpen = item.classList.contains('is-open');
    document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('is-open'); });
    if (!wasOpen) item.classList.add('is-open');
  });
});

// Bundle — toggle cards, live total, add-to-cart
(function () {
  var bundle = document.querySelector('[data-bundle]');
  if (!bundle) return;
  var cards = bundle.querySelectorAll('[data-bundle-card]');
  var priceEl = bundle.querySelector('[data-bundle-price]');
  var labelEl = bundle.querySelector('[data-bundle-label]');
  var countEl = bundle.querySelector('[data-bundle-count]');
  var addBtn = bundle.querySelector('[data-bundle-add]');
  var discountPct = parseFloat(bundle.dataset.discountPct) || 0;
  var discountThreshold = parseInt(bundle.dataset.discountThreshold, 10) || 3;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';

  function formatPrice(cents) {
    var kr = cents / 100;
    // Danish: dot thousands, no trailing decimals when .00
    var whole = Math.round(kr);
    var s = whole.toLocaleString('da-DK');
    return s + ' kr.';
  }

  function recalc() {
    var subtotal = 0;
    var onCount = 0;
    cards.forEach(function (card) {
      if (card.classList.contains('is-on')) {
        subtotal += parseInt(card.dataset.price, 10) || 0;
        onCount += 1;
      }
    });
    var total = subtotal;
    var discountApplied = false;
    if (discountPct > 0 && onCount >= discountThreshold) {
      total = Math.round(subtotal * (1 - discountPct / 100));
      discountApplied = true;
    }
    // Render
    if (priceEl) {
      if (discountApplied) {
        priceEl.innerHTML = formatPrice(total) +
          '<span class="bundle-total__was">' + formatPrice(subtotal) + '</span>';
      } else {
        priceEl.textContent = formatPrice(total);
      }
    }
    if (countEl) countEl.textContent = onCount;
    if (labelEl) {
      var plural = onCount === 1 ? 'stykke' : 'stykker';
      var discountTag = discountApplied ? ' · ' + discountPct + '% bundle-rabat' : '';
      labelEl.innerHTML = '<span data-bundle-count>' + onCount + '</span> ' + plural + ' valgt' + discountTag;
    }
    if (addBtn) {
      addBtn.disabled = onCount === 0;
      addBtn.style.opacity = onCount === 0 ? '0.5' : '';
    }
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      // Don't toggle if clicking an interactive child (future-proofing)
      if (e.target.closest('a, button, input, select')) return;
      card.classList.toggle('is-on');
      recalc();
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var items = [];
      cards.forEach(function (card) {
        if (card.classList.contains('is-on') && card.dataset.variantId) {
          items.push({ id: parseInt(card.dataset.variantId, 10), quantity: 1 });
        }
      });
      if (!items.length) return;
      addBtn.disabled = true;
      addBtn.querySelector('span').textContent = 'Tilføjer…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.querySelector('span').textContent = 'Prøv igen';
        });
    });
  }

  recalc();
})();

// Anatomy hover sync
document.querySelectorAll('.anat-item').forEach(function(item) {
  item.addEventListener('mouseenter', function() {
    var hot = item.dataset.hot;
    document.querySelectorAll('.anat-layer').forEach(function(l) { l.classList.remove('is-hot'); });
    var target = document.querySelector('.anat-layer.' + hot);
    if (target) target.classList.add('is-hot');
  });
  item.addEventListener('mouseleave', function() {
    document.querySelectorAll('.anat-layer').forEach(function(l) { l.classList.remove('is-hot'); });
  });
});

// Reveal on scroll
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('is-in');
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: 0.14 });
document.querySelectorAll('.reveal').forEach(function(el) { revealObs.observe(el); });

// Real shipping cutoff messaging is handled by assets/s2c-shipping-cutoff.js

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2c-redesign-header"]) return;
  try {
    
  (function(){
    'use strict';

    // Sticky scroll → header shrink
    var header = document.getElementById('s2c-header');
    if (header) {
      window.addEventListener('scroll', function(){
        header.classList.toggle('is-scrolled', window.scrollY > 40);
      }, { passive: true });
    }

    // Mega-menu hover (desktop)
    var triggers = document.querySelectorAll('[data-menu-target]');
    var megas = document.querySelectorAll('[data-mega-panel]');

    function closeAllMegas() {
      megas.forEach(function(m){
        m.classList.remove('is-open');
        m.setAttribute('aria-hidden', 'true');
      });
      triggers.forEach(function(t){
        t.classList.remove('is-active');
        t.setAttribute('aria-expanded', 'false');
      });
    }

    triggers.forEach(function(t){
      t.addEventListener('mouseenter', function(){
        closeAllMegas();
        var target = document.querySelector('[data-mega-panel="' + t.dataset.menuTarget + '"]');
        if (target) {
          target.classList.add('is-open');
          target.setAttribute('aria-hidden', 'false');
          t.classList.add('is-active');
          t.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Close mega on header mouseleave
    if (header) {
      header.addEventListener('mouseleave', closeAllMegas);
    }

    // Close mega on Escape
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') {
        closeAllMegas();
        var search = document.getElementById('s2c-search');
        if (search) search.classList.remove('is-open');
      }
    });

    // Close mega on outside click
    document.addEventListener('click', function(e){
      if (header && !header.contains(e.target)) {
        closeAllMegas();
      }
    });

    // Mobile menu toggle
    var mobileMenu = document.getElementById('s2c-mobile-menu');
    document.querySelectorAll('[data-mobile-open]').forEach(function(b){
      b.addEventListener('click', function(){
        if (mobileMenu) {
          mobileMenu.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });
    });
    document.querySelectorAll('[data-mobile-close]').forEach(function(b){
      b.addEventListener('click', function(){
        if (mobileMenu) {
          mobileMenu.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    });

    // Mobile submenu drill-down
    document.querySelectorAll('[data-submenu-target]').forEach(function(b){
      b.addEventListener('click', function(){
        var panel = document.querySelector('[data-submenu-panel="' + b.dataset.submenuTarget + '"]');
        if (panel) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        }
      });
    });
    document.querySelectorAll('[data-submenu-close]').forEach(function(b){
      b.addEventListener('click', function(){
        var panel = b.closest('.s2c-mobile-submenu');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
        }
      });
    });

    // Search overlay
    var search = document.getElementById('s2c-search');
    var searchInput = document.querySelector('.s2c-search__input');

    function openSearch() {
      if (search) {
        search.classList.add('is-open');
        setTimeout(function(){
          if (searchInput) searchInput.focus();
        }, 300);
      }
    }

    function closeSearch() {
      if (search) search.classList.remove('is-open');
    }

    document.querySelectorAll('[data-search-open], [data-search-open-mobile]').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        openSearch();
      });
    });

    document.querySelectorAll('[data-search-close]').forEach(function(b){
      b.addEventListener('click', closeSearch);
    });

    // Predictive search
    var results = document.getElementById('s2c-search-results');
    var debounce;

    if (searchInput && results) {
      searchInput.addEventListener('input', function(e){
        clearTimeout(debounce);
        var q = e.target.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        debounce = setTimeout(function(){
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
            .then(function(r){ return r.json(); })
            .then(function(d){
              var items = (d.resources && d.resources.results && d.resources.results.products) || [];
              results.innerHTML = items.map(function(p){
                return '<a class="s2c-search__result" href="' + p.url + '">' +
                  (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">' : '') +
                  '<div><div>' + p.title + '</div><div>' + (p.price || '') + '</div></div>' +
                '</a>';
              }).join('');
            })
            .catch(function(){});
        }, 200);
      });
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
